/* eslint-disable */
// this is an auto generated file. This will be overwritten

//EDITED
export const batchAddFieldTemplates = /* GraphQL */ `
	mutation BatchAddFieldTemplates($fieldTemplates: [CreateFieldTemplateInput]) {
		batchAddFieldTemplates(fieldTemplates: $fieldTemplates) {
			id
		}
	}
`;

export const batchAddFormTemplates = /* GraphQL */ `
	mutation BatchAddFormTemplates($formTemplates: [CreateFormTemplateInput]) {
		batchAddFormTemplates(formTemplates: $formTemplates) {
			id
		}
	}
`;

export const batchAddRevisions = /* GraphQL */ `
	mutation BatchAddRevisions($revisions: [CreateRevisionInput]) {
		batchAddRevisions(revisions: $revisions) {
			id
		}
	}
`;

//EDITED
export const batchAddFieldContinuationData = /* GraphQL */ `
	mutation BatchAddFieldContinuationData($continuationdata: [CreateFieldContinuationDataInput]) {
		batchAddFieldContinuationData(continuationdata: $continuationdata) {
			id
		}
	}
`;

//EDITED
export const batchAddFieldInstances = /* GraphQL */ `
	mutation BatchAddFieldInstances($fieldInstances: [CreateFieldInstanceInput]) {
		batchAddFieldInstances(fieldInstances: $fieldInstances) {
			id
			formInstance
			formGroup
			value
			altInstanceId
			tableField
			fieldsOrder
			sortingPriority
			notes
			authors
			lastAuthor
			editing
			group
		}
	}
`;

//EDITED
export const batchAddImages = /* GraphQL */ `
	mutation BatchAddImages($images: [CreateImageInput]) {
		batchAddImages(images: $images) {
			id
			key
			rotation
			dpi
			aspectX
			aspectY
			createdAt
			updatedAt
			formGroup
			project
			group
		}
	}
`;

//EDITED
export const batchAddFormInstances = /* GraphQL */ `
	mutation BatchAddFormInstances($formInstances: [CreateFormInstanceInput]) {
		batchAddFormInstances(formInstances: $formInstances) {
			id
		}
	}
`;

//EDITED
export const batchAddFormGroups = /* GraphQL */ `
	mutation BatchAddFormGroups($formGroups: [CreateFormGroupInput]) {
		batchAddFormGroups(formGroups: $formGroups) {
			id
		}
	}
`;

//EDITED
export const batchDeleteFieldInstances = /* GraphQL */ `
	mutation BatchDeleteFieldInstances($fieldInstances: [DeleteFieldInstanceInput]) {
		batchDeleteFieldInstances(fieldInstances: $fieldInstances) {
			id
		}
	}
`;

//EDITED
export const batchDeleteRevisions = /* GraphQL */ `
	mutation BatchDeleteRevisions($revisions: [DeleteRevisionInput]) {
		batchDeleteRevisions(revisions: $revisions) {
			id
		}
	}
`;

//EDITED
export const batchDeleteImages = /* GraphQL */ `
	mutation BatchDeleteImages($images: [DeleteImageInput]) {
		batchDeleteImages(images: $images) {
			id
		}
	}
`;

//EDITED
export const batchDeleteFormGroups = /* GraphQL */ `
	mutation BatchDeleteFormGroups($formGroups: [DeleteFormGroupInput]) {
		batchDeleteFormGroups(formGroups: $formGroups) {
			id
		}
	}
`;

// EDITED
export const batchAddOptions = /* GraphQL */ `
	mutation BatchAddOptions($options: [CreateOptionInput]) {
		batchAddOptions(options: $options) {
			id
		}
	}
`;

// EDITED
export const batchDeleteOptions = /* GraphQL */ `
	mutation BatchDeleteOptions($options: [DeleteOptionInput]) {
		batchDeleteOptions(options: $options) {
			id
		}
	}
`;

// EDITED
export const batchDeleteFieldContinuationData = /* GraphQL */ `
	mutation batchDeleteFieldContinuationData($continuationData: [DeleteFieldContinuationDataInput]) {
		batchDeleteFieldContinuationData(continuationData: $continuationData) {
			id
		}
	}
`;

// EDITED
export const batchDeleteFormInstances = /* GraphQL */ `
	mutation BatchDeleteFormInstances($formInstances: [DeleteFormInstanceInput]) {
		batchDeleteFormInstances(formInstances: $formInstances) {
			id
		}
	}
`;

// EDITED
export const batchDeleteFieldTemplates = /* GraphQL */ `
	mutation batchDeleteFieldTemplates($fieldTemplates: [DeleteFieldTemplateInput]) {
		batchDeleteFieldTemplates(fieldTemplates: $fieldTemplates) {
			id
		}
	}
`;

// EDITED
export const createFormTemplate = /* GraphQL */ `
	mutation CreateFormTemplate($input: CreateFormTemplateInput!, $condition: ModelFormTemplateConditionInput) {
		createFormTemplate(input: $input, condition: $condition) {
			id
		}
	}
`;

// EDITED
export const updateFormTemplate = /* GraphQL */ `
	mutation UpdateFormTemplate($input: UpdateFormTemplateInput!, $condition: ModelFormTemplateConditionInput) {
		updateFormTemplate(input: $input, condition: $condition) {
			id
		}
	}
`;

// EDITED
export const updateImage = /* GraphQL */ `
	mutation UpdateImage($input: UpdateImageInput!, $condition: ModelImageConditionInput) {
		updateImage(input: $input, condition: $condition) {
			id
			key
			rotation
			dpi
			aspectX
			aspectY
			createdAt
			updatedAt
			formGroup
			project
			group
		}
	}
`;

// EDITED
export const createFormGroup = /* GraphQL */ `
	mutation CreateFormGroup($input: CreateFormGroupInput!, $condition: ModelFormGroupConditionInput) {
		createFormGroup(input: $input, condition: $condition) {
			id
		}
	}
`;

// EDITED
export const updateFormGroup = /* GraphQL */ `
	mutation UpdateFormGroup($input: UpdateFormGroupInput!, $condition: ModelFormGroupConditionInput) {
		updateFormGroup(input: $input, condition: $condition) {
			id
			users
			name
			type
			formOrder
			group
			createdAt
			updatedAt
			syncedAt
			lastUpdatedBy
		}
	}
`;

// EDITED
export const updateFormInstance = /* GraphQL */ `
	mutation UpdateFormInstance($input: UpdateFormInstanceInput!, $condition: ModelFormInstanceConditionInput) {
		updateFormInstance(input: $input, condition: $condition) {
			id
			updatedAt
		}
	}
`;

// EDITED
export const deleteFormGroup = /* GraphQL */ `
	mutation DeleteFormGroup($input: DeleteFormGroupInput!, $condition: ModelFormGroupConditionInput) {
		deleteFormGroup(input: $input, condition: $condition) {
			id
		}
	}
`;

// EDITED
export const createFormInstance = /* GraphQL */ `
	mutation CreateFormInstance($input: CreateFormInstanceInput!, $condition: ModelFormInstanceConditionInput) {
		createFormInstance(input: $input, condition: $condition) {
			id
		}
	}
`;

// EDITED
export const deleteFormInstance = /* GraphQL */ `
	mutation DeleteFormInstance($input: DeleteFormInstanceInput!, $condition: ModelFormInstanceConditionInput) {
		deleteFormInstance(input: $input, condition: $condition) {
			id
		}
	}
`;

// EDITED
export const deleteFormTemplate = /* GraphQL */ `
	mutation DeleteFormTemplate($input: DeleteFormTemplateInput!, $condition: ModelFormTemplateConditionInput) {
		deleteFormTemplate(input: $input, condition: $condition) {
			id
		}
	}
`;

// EDITED
export const createProject = /* GraphQL */ `
	mutation CreateProject($input: CreateProjectInput!, $condition: ModelProjectConditionInput) {
		createProject(input: $input, condition: $condition) {
			users
			name
			description
			public
			group
			formGroups {
				items {
					id
					users
					type
					name
					formOrder
					projectId
					formInstances {
						items {
							formTemplate {
								template
								description
								id
								group
								readGroups
								createdAt
								updatedAt
							}
							id
							group
							createdAt
							updatedAt
						}
						nextToken
					}
					group
					createdAt
					updatedAt
					syncedAt
					lastUpdatedBy
				}
				nextToken
			}
			id
		}
	}
`;

export const updateProject = /* GraphQL */ `
	mutation UpdateProject($input: UpdateProjectInput!, $condition: ModelProjectConditionInput) {
		updateProject(input: $input, condition: $condition) {
			id
			forceUpdateData
			users
			name
			description
			group
			public
		}
	}
`;

// EDITED
export const updateFieldInstance = /* GraphQL */ `
	mutation UpdateFieldInstance($input: UpdateFieldInstanceInput!, $condition: ModelFieldInstanceConditionInput) {
		updateFieldInstance(input: $input, condition: $condition) {
			id
			formInstance
			formGroup
			image {
				id
				dpi
				key
				rotation
				aspectX
				aspectY
				project
				formGroup
			}
			forceUpdateData
			imageId
			fieldTemplateId
			value
			tableField
			fieldsOrder
			sortingPriority
			altInstanceId
			notes
			authors
			editing
			group
			createdAt
			updatedAt
		}
	}
`;

// EDITED
export const createUser = /* GraphQL */ `
	mutation CreateUser($input: CreateUserInput!, $condition: ModelUserConditionInput) {
		createUser(input: $input, condition: $condition) {
			id
			username
			email
			group
			hideTutorial
			isDeveloper
			lightMode
			createdAt
			updatedAt
		}
	}
`;

// EDITED
export const updateUser = /* GraphQL */ `
	mutation UpdateUser($input: UpdateUserInput!, $condition: ModelUserConditionInput) {
		updateUser(input: $input, condition: $condition) {
			id
			username
			email
			group
			hideTutorial
			isDeveloper
			lightMode
			createdAt
			updatedAt
		}
	}
`;

export const createMessage = /* GraphQL */ `
	mutation CreateMessage($input: CreateMessageInput!, $condition: ModelMessageConditionInput) {
		createMessage(input: $input, condition: $condition) {
			id
			subject
			from
			message
			group
			projects
		}
	}
`;

export const batchAddUserMessages = /* GraphQL */ `
	mutation BatchAddUserMessages($userMessages: [CreateUserMessageInput]) {
		batchAddUserMessages(userMessages: $userMessages) {
			id
			userId
			messageId
			group
			read
		}
	}
`;

export const updateUserMessage = /* GraphQL */ `
	mutation UpdateUserMessage($input: UpdateUserMessageInput!, $condition: ModelUserMessageConditionInput) {
		updateUserMessage(input: $input, condition: $condition) {
			id
			userId
			messageId
			group
			read
		}
	}
`;

export const batchAddProjects = /* GraphQL */ `
	mutation BatchAddProjects($projects: [CreateProjectInput]) {
		batchAddProjects(projects: $projects) {
			id
		}
	}
`;

export const deleteProjectLambda = /* GraphQL */ `
	mutation DeleteProjectLambda($projectId: String!) {
		deleteProjectLambda(projectId: $projectId)
	}
`;

export const uploadFromCSVLambda = /* GraphQL */ `
	mutation UploadFromCSVLambda($csvStringifiedArray: String!, $projectId: String!) {
		uploadFromCSVLambda(csvStringifiedArray: $csvStringifiedArray, projectId: $projectId)
	}
`;

export const setAutoSyncFormTemplatesLambda = /* GraphQL */ `
	mutation SetAutoSyncFormTemplatesLambda($projectId: String!, $formTemplateIds: [String!]!, $action: String!) {
		setAutoSyncFormTemplatesLambda(projectId: $projectId, formTemplateIds: $formTemplateIds, action: $action)
	}
`;

export const deleteFormGroupsLambda = /* GraphQL */ `
	mutation DeleteFormGroupsLambda($stringifiedFormGroupIdArray: String!) {
		deleteFormGroupsLambda(stringifiedFormGroupIdArray: $stringifiedFormGroupIdArray)
	}
`;

export const saveOfflineDataToCloudLambda = /* GraphQL */ `
	mutation SaveOfflineDataToCloudLambda($stringifiedMergeDataToSave: String!) {
		saveOfflineDataToCloudLambda(stringifiedMergeDataToSave: $stringifiedMergeDataToSave)
	}
`;

export const createImageRouteLambda = /* GraphQL */ `
	mutation CreateImageRouteLambda($key: String!) {
		createImageRoute(key: $key) {
			compressedBucket
			compressionBucketSuccess
			compressedKey
			message
			operationSuccess
			sourceBucket
			sourceBucketSuccess
			sourceKey
		}
	}
`;

export const copyImageRouteLambda = /* GraphQL */ `
	mutation CopyImageRouteLambda($key: String!) {
		copyImageRoute(key: $key) {
			compressedBucket
			compressionBucketSuccess
			compressedKey
			message
			operationSuccess
			sourceBucket
			sourceBucketSuccess
			sourceKey
		}
	}
`;

export const deleteImageRouteLambda = /* GraphQL */ `
	mutation DeleteImageRouteLambda($key: String!) {
		deleteImageRoute(key: $key) {
			compressedBucket
			compressionBucketSuccess
			compressedKey
			message
			operationSuccess
			sourceBucket
			sourceBucketSuccess
			sourceKey
		}
	}
`;

// Aliases matching the Amplify-generated mutations.ts names
export { createImageRouteLambda as createImageRoute };
export { copyImageRouteLambda as copyImageRoute };
export { deleteImageRouteLambda as deleteImageRoute };

export const createRole = /* GraphQL */ `
	mutation CreateRole($input: CreateRoleInput!) {
		createRole(input: $input) {
			id
			description
			name
			permissionIds
			group
			readGroups
			createdAt
			updatedAt
		}
	}
`;

export const updateRole = /* GraphQL */ `
	mutation UpdateRole($input: CreateRoleInput!) {
		updateRole(role: $input) {
			id
			description
			name
			permissionIds
			group
			readGroups
			createdAt
			updatedAt
		}
	}
`;

export const deleteRole = /* GraphQL */ `
	mutation DeleteRole($id: String!) {
		deleteRole(id: $id) {
			id
		}
	}
`;

export const createPermission = /* GraphQL */ `
	mutation CreatePermission($input: CreatePermissionInput!) {
		createPermission(input: $input) {
			id
			description
			name
			group
			value
			createdAt
			updatedAt
		}
	}
`;

export const updatePermission = /* GraphQL */ `
	mutation UpdatePermission($input: CreatePermissionInput!) {
		updatePermission(input: $input) {
			id
			description
			name
			group
			value
			createdAt
			updatedAt
		}
	}
`;

export const deletePermission = /* GraphQL */ `
	mutation DeletePermission($id: String!) {
		deletePermission(id: $id) {
			id
		}
	}
`;

export const exportFormGroupsLambda = /* GraphQL */ `
	mutation ExportFormGroups($exportFormGroupsData: ExportFormGroupsData!) {
		exportFormGroups(exportFormGroupsData: $exportFormGroupsData) {
			error
			message
			signedUrl
		}
	}
`;

// Analytics Event Mutations
export const createAnalyticsEvent = /* GraphQL */ `
	mutation CreateAnalyticsEvent($input: CreateAnalyticsEventInput!) {
		createAnalyticsEvent(input: $input) {
			id
			eventType
			userId
			groupId
			timestamp
			clientTimestamp
			sessionId
			deviceType
			metadata
			appVersion
			offlineQueued
			ttl
		}
	}
`;

export const batchCreateAnalyticsEvents = /* GraphQL */ `
	mutation BatchCreateAnalyticsEvents($events: [CreateAnalyticsEventInput!]!) {
		batchCreateAnalyticsEvents(events: $events) {
			id
			eventType
			userId
			groupId
			timestamp
			sessionId
			deviceType
			appVersion
		}
	}
`;

export const createAnalyticsAggregate = /* GraphQL */ `
	mutation CreateAnalyticsAggregate($input: CreateAnalyticsAggregateInput!) {
		createAnalyticsAggregate(input: $input) {
			id
			metricType
			period
			value
			groupId
			metadata
			ttl
		}
	}
`;

export const updateAnalyticsAggregate = /* GraphQL */ `
	mutation UpdateAnalyticsAggregate($input: UpdateAnalyticsAggregateInput!) {
		updateAnalyticsAggregate(input: $input) {
			id
			metricType
			period
			value
			groupId
			metadata
			ttl
		}
	}
`;

export const deleteAnalyticsEvent = /* GraphQL */ `
	mutation DeleteAnalyticsEvent($input: DeleteAnalyticsEventInput!) {
		deleteAnalyticsEvent(input: $input) {
			id
		}
	}
`;
